"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SupplierAfterSalesPanel',
  props: {
    orderNo: {
      type: String,
      default: ''
    },
    refundOrderNo: {
      type: String,
      default: ''
    },
    logisticsCompany: {
      type: String,
      default: ''
    },
    logisticsNo: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      syncLoading: false,
      loaded: false,
      afterSales: null
    };
  },
  computed: {
    imageList: function imageList() {
      if (!this.afterSales || !this.afterSales.imageUrl) return [];
      return String(this.afterSales.imageUrl).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    }
  },
  watch: {
    active: function active(val) {
      if (val && !this.loaded) this.getDetail();
    },
    orderNo: function orderNo() {
      this.afterSales = null;
      this.loaded = false;
      if (this.active) this.getDetail();
    }
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      if (!this.orderNo) return;
      this.loading = true;
      (0, _order.getSupplierAfterSalesDetailApi)({
        orderNo: this.orderNo,
        refundOrderNo: this.refundOrderNo
      }).then(function (res) {
        _this.afterSales = _this.resolveAfterSalesResponse(res) || null;
        _this.loaded = true;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSyncStatus: function handleSyncStatus() {
      var _this2 = this;
      if (!this.orderNo) return;
      this.syncLoading = true;
      this.$message.info('正在同步供应商售后状态');
      (0, _order.getSupplierAfterSalesDetailApi)({
        orderNo: this.orderNo,
        refundOrderNo: this.refundOrderNo
      }).then(function (res) {
        _this2.afterSales = _this2.resolveAfterSalesResponse(res) || null;
        _this2.loaded = true;
        _this2.$message.success('同步售后状态已执行');
      }).finally(function () {
        _this2.syncLoading = false;
      });
    },
    resolveAfterSalesResponse: function resolveAfterSalesResponse(res) {
      if (!res) return null;
      if (res.data) return res.data;
      if (res.result) return res.result;
      return res;
    },
    valueOrDash: function valueOrDash(value) {
      if (value === 0 || value === false) return value;
      return value || '-';
    },
    formatMoney: function formatMoney(value) {
      if (value === 0 || value) return "\uFFE5".concat(value);
      return '-';
    },
    joinError: function joinError(code, info) {
      if (!code && !info) return '-';
      return [code, info].filter(Boolean).join(' / ');
    },
    joinDelivery: function joinDelivery(company, no) {
      if (!company && !no) return '-';
      return [company, no].filter(Boolean).join(' / ');
    },
    formatCancelStatus: function formatCancelStatus(status) {
      if (status === true) return '已取消';
      if (status === false) return '未取消';
      return '-';
    },
    formatStatus: function formatStatus(status) {
      var map = {
        0: '已申请',
        1: '已发货',
        2: '已完成',
        '-1': '已取消'
      };
      return map[status] || this.valueOrDash(status);
    },
    statusTagType: function statusTagType(status) {
      if (status === 2) return 'success';
      if (status === -1) return 'danger';
      if (status === 0) return 'warning';
      if (status === 1) return '';
      return 'info';
    }
  }
};